import { render, staticRenderFns } from "./PublishRequestPagesList.vue?vue&type=template&id=a112d87a"
import script from "./PublishRequestPagesList.vue?vue&type=script&lang=js"
export * from "./PublishRequestPagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports